import { useState, useRef, useEffect } from "react";
import styled from "styled-components";

const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const DropdownHeader = styled.div`
  width: 100%;
  padding: 12px;
  border: 1px solid #e2e2ea;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  cursor: pointer;
  color: ${(props) => (props.value ? "#333" : "#8e8e8e")};
  transition: all 0.2s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover,
  &:focus {
    border-color: #149dff;
  }
`;

const OptionsList = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e2e2ea;
  border-radius: 8px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const Option = styled.div`
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #149dff;
    color: white;
  }
`;

const ArrowIcon = styled.div`
  width: 8px;
  height: 8px;
  border-right: 2px solid #8e8e8e;
  border-bottom: 2px solid #8e8e8e;
  transform: rotate(${(props) => (props.isOpen ? "225deg" : "45deg")});
  transition: transform 0.2s ease;
`;

const Dropdown = ({
  options = [],
  value,
  onChange,
  placeholder = "Select an option",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selectedOption = options.find((opt) => opt.value === value);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  return (
    <DropdownWrapper ref={dropdownRef}>
      <DropdownHeader onClick={() => setIsOpen(!isOpen)} value={value}>
        {selectedOption ? selectedOption.label : placeholder}
        <ArrowIcon isOpen={isOpen} />
      </DropdownHeader>

      {isOpen && (
        <OptionsList>
          {options.map((option) => (
            <Option key={option.value} onClick={() => handleSelect(option)}>
              {option.label}
            </Option>
          ))}
        </OptionsList>
      )}
    </DropdownWrapper>
  );
};

export default Dropdown;
